export default function Hero() {
  return (
    <section id="hero" className="relative pt-[72px] min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/25 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-5">
              免费高清 · 不缓冲秒开播
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              小草影院 · 免费在线看高清电影
            </h1>
            <p className="text-base md:text-lg text-primary-500 font-heading mb-6">
              无需注册，即点即看，流畅观影体验
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[640px] mx-auto lg:mx-0 mb-8">
              小草影院是一个完全免费的在线观影平台，汇集海量高清电影、热门电视剧与经典动漫资源。全站内容无需注册、不收费、不缓冲，点击即可秒开播放。每日同步更新院线新片与各大平台热播剧集，覆盖动作、喜剧、科幻、爱情、悬疑、纪录片等多种题材。无论您是想追最新大片还是重温经典老片，小草影院都能为您提供流畅无阻的高清观影体验。本站持续扩展内容库，目前已有数万部影片资源，且每周新增数百部，是您免费追剧观影的首选平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">50,000+</div>
                <div className="text-xs text-foreground-500 mt-1">高清影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">300+ 内容上架</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">秒开不卡</div>
                <div className="text-xs text-foreground-500 mt-1">全线路 CDN 加速</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门榜单
              </a>
              <a
                href="#cards"
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-lg border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors"
              >
                <i className="ri-movie-2-line text-lg"></i>
                探索精彩推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20illustration%20of%20a%20cozy%20home%20theater%20setting%20with%20a%20large%20glowing%20screen%20showing%20abstract%20film%20reel%20and%20light%20beams%2C%20surrounded%20by%20comfortable%20seating%2C%20warm%20amber%20and%20coral%20lighting%2C%20soft%20ambient%20atmosphere%2C%20clean%20minimal%20composition%20with%20cinematic%20mood%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20warm%20tones&width=800&height=600&seq=xiaocao-hero-2026&orientation=landscape"
                alt="小草影院高清观影体验"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const el = e.currentTarget;
                  el.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}